import '@/assets/css/tailwind.css'
import '@/assets/css/main.scss'
import '@/assets/css/theme/index.css'

import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.use(ElementUI)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
